import { useEffect, useState, useCallback } from "react";
import { useAuth } from "@/modules/authentication/context/AuthContext";
import { useLiveKit } from "../contexts";
import { toast } from "sonner";

export const useMeetingConnection = (
  meetingCode: string | undefined,
  onShowJoinDialog: () => void
) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const { connectToMeeting, error } = useLiveKit();
  const [hasAttemptedConnection, setHasAttemptedConnection] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const initConnection = async () => {
      if (!isMounted || !meetingCode || hasAttemptedConnection || isLoading) {
        return;
      }

      setHasAttemptedConnection(true);
      try {
        if (isAuthenticated && user?.id && user?.fullName) {
          await connectToMeeting(meetingCode, user.id, user.fullName);
          return;
        }

        onShowJoinDialog();
      } catch (error) {
        console.error("Error connecting to meeting:", error);
        onShowJoinDialog();
      }
    };

    initConnection();

    return () => {
      isMounted = false;
    };
  }, [
    meetingCode,
    isAuthenticated,
    user?.id,
    user?.fullName,
    connectToMeeting,
    hasAttemptedConnection,
    isLoading,
    onShowJoinDialog,
  ]);

  const handleJoinMeeting = useCallback(
    async (name: string, userId: string): Promise<boolean> => {
      if (!meetingCode) {
        toast.error("Mã cuộc họp không hợp lệ");
        return false;
      }

      try {
        await connectToMeeting(meetingCode, userId, name);
        if (!error) {
          return true;
        }
      } catch (err) {
        console.error("Error connecting to meeting:", err);
      }
      return false;
    },
    [meetingCode, connectToMeeting, error]
  );

  return {
    handleJoinMeeting,
    hasAttemptedConnection,
  };
};

